import { AjaxBasics } from '@xt/client'
import moment from 'moment'

type VisibleFrame = {
  type: 'hidden' | 'visible'
  begin: number
  end: number
  duration: number
}

export class VisibleTrack {
  private isRecording = false
  private frames: VisibleFrame[] = []
  private lastTrackTime: number | null = null
  private currentStatus: 'hidden' | 'visible'

  constructor() {
    this.currentStatus = 'visible'
    this.lastTrackTime = this.getServerTime()
    // console.log('begin', this.lastTrackTime)
    this.hanldeVisibilityChange = this.hanldeVisibilityChange.bind(this)
    this.stop = this.stop.bind(this)
  }

  private getServerTime() {
    return AjaxBasics.serviceDate.valueOf()
  }

  private appendFrame(eventType: 'hidden' | 'visible', begin: number, end: number) {
    this.frames.push({ type: eventType, begin, end, duration: end - begin })
  }

  private hanldeVisibilityChange() {
    const now = this.getServerTime()
    
    this.currentStatus = document.visibilityState
    // console.warn('DEBUG ----> current status: ', this.currentStatus, now, moment(now).format('YYYY-MM-DD HH:mm:ss'))

    this.appendFrame(this.currentStatus === 'visible' ? 'hidden' : 'visible', this.lastTrackTime!, now)

    this.lastTrackTime = now
  }

  record() {
    if (this.isRecording) return

    this.isRecording = true

    document.addEventListener('visibilitychange', this.hanldeVisibilityChange)

    window.addEventListener('beforeunload', this.stop)
  }

  stop() {
    this.isRecording = false

    document.removeEventListener('visibilitychange', this.hanldeVisibilityChange)
  }

  export() {
    return this.frames
  }

  flush() {
    const now = this.getServerTime()
    // 特殊处理一下，如果本次chunk收集到的数据为空，那么填充完整的暂停数据并上报
    if (this.frames.length === 0) {
      this.appendFrame(this.currentStatus, this.lastTrackTime!, now)

      this.lastTrackTime = now
    }

    const result: Record<string, any> = {}
    const actionFrames = this.frames.filter(item => item.type === 'visible')
    const pauseFrames = this.frames.filter(item => item.type === 'hidden')
    const actionTotal = actionFrames.reduce((prev, current) => {
      return prev + current.duration
    }, 0)
    const pauseTotal = pauseFrames.reduce((prev, current) => {
      return prev + current.duration
    }, 0)
    const total = actionTotal + pauseTotal

    result.actionTotal = actionTotal
    result.pauseTotal = pauseTotal
    result.total = total
    result.frames = [...this.frames]

    this.frames = []
    return result
  }
}
